export enum BenchmarkMosaicSize {
  /** Wide cells that read as a strip across the top of a card. */
  Card = 'card',
  /** A small square thumbnail that sits inline next to text. */
  Thumbnail = 'thumbnail',
}

export interface BenchmarkMosaicProps {
  /**
   * The benchmark name; keys the cells and names the mosaic for assistive tech
   */
  name: string;
  /**
   * Up to four thumbnail URLs; missing cells render empty
   */
  urls?: string[];
  /**
   * Whether to render skeleton cells instead of images
   *
   * @default false
   */
  isLoading?: boolean;
  /**
   * The mosaic layout
   *
   * @default BenchmarkMosaicSize.Card
   */
  size?: BenchmarkMosaicSize;
  /**
   * Additional classes for the grid
   */
  className?: string;
}
